export const crmPaymentsColumns = [
  {
    title: 'Тип пополнения',
    dataIndex: 'type',
    width: '15%',
  },
  {
    title: 'Сумма',
    dataIndex: 'amount',
    width: '10%',
  },
  {
    title: 'Баланс',
    dataIndex: 'balance',
    width: '15%',
  },
  {
    title: 'Описание',
    dataIndex: 'description',
  },
  {
    title: 'Дата',
    dataIndex: 'createdAt',
    width: '10%',
  },
]
